import { Case, CareOf, CaseCustomer, CaseStatus } from 'app/domain/cases/case.model';
import { assertNever } from 'app/shared/utils/assert-never';

export interface CaseCreateSuccess extends Case {
  statusLabel: string;
}

export const customerName = (customer: CaseCustomer): string => {
  switch (customer.type) {
    case 'private':
      return `${customer.firstName} ${customer.lastName}`;
    case 'business':
      return customer.companyName;
    default:
      return assertNever(customer);
  }
};

const joinPresent = (parts: (string | undefined)[]): string => parts.filter(Boolean).join(' ');

const careOfName = ({ salutation, title, lastName }: CareOf): string => joinPresent([salutation, title, lastName]);

const businessContactName = (companyName: string, careOf?: CareOf): string =>
  careOf ? `${careOfName(careOf)} - ${companyName}` : companyName;

export const contactName = (customer: CaseCustomer): string => {
  switch (customer.type) {
    case 'private':
      return joinPresent([customer.salutation, customer.title, customer.firstName, customer.lastName]);
    case 'business':
      return businessContactName(customer.companyName, customer.careOf);
    default:
      return assertNever(customer);
  }
};

export const statusLabel = (status: CaseStatus): string => {
  switch (status) {
    case 'OPEN':
      return 'Offen';
    case 'CLOSED':
      return 'Abgeschlossen';
  }
};

export const toCaseCreateSuccess = (c: Case): CaseCreateSuccess => ({
  ...c,
  statusLabel: statusLabel(c.status),
});
